"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MokuChatCustom = exports.CloseButton = exports.MokuBubble = exports.MokuNotePanelContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const mokuChat_svg_1 = __importDefault(require("../../../images/svgs/mokuChat.svg"));
const theme_style_1 = __importDefault(require("../../../theme.style"));
const MokuNotePanelContainer = styled_1.default.div `
  position: relative;
  background: ${(props) => `${props.theme.colors[props.color || 'primary']}${props.color && !props.transparent ? '' : '19'}`};
  border-radius: 4px;
  // margin-bottom: 12px;
  // padding-left: 11px;
  // padding-right: 11px;
  // padding-top: 14px;
  // padding-bottom: 14px;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;

  ${(props) => !props.visible && `display: none;`}
`;
exports.MokuNotePanelContainer = MokuNotePanelContainer;
const MokuBubble = styled_1.default.img `
  width: 39.18px;
  height: 38.58px;
  margin: 0;
  max-width: 40px;
`;
exports.MokuBubble = MokuBubble;
const CloseButton = styled_1.default.img `
  position: absolute;
  right: 11px;
  top: 8px;
  margin: 0;
  width: 16px;
  height: 16px;
`;
exports.CloseButton = CloseButton;
const MokuChatCustom = styled_1.default(mokuChat_svg_1.default) `
  width: 53px;
  height: 53px;
  ${(props) => `&>path{
    fill: ${props.color || theme_style_1.default.colors.primary};
  }`}
`;
exports.MokuChatCustom = MokuChatCustom;
